<template>
    <v-toolbar color="#2B3848" dark class="fixed-bar">
        <v-icon class="mr-4">{{ icon }}</v-icon>
        <v-toolbar-title v-if="searching === false" class="mr-4 d-flex flex-column align-center">
            <template v-if="subtitle">
                <span class="d-flex">
                    <span class="font-weight-thin">{{ title }} |</span>
                    <span class="ml-1">{{ subtitle }}</span>
                </span>
            </template>
            <template v-else>
                <span class="font-weight-thin">{{ title }}</span>
            </template>
        </v-toolbar-title>

        <template v-if="!loading">
            <v-text-field
                v-if="!hideSearchBar"
                flat
                solo-inverted
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                :label="searchLabel"
                class="hidden-sm-and-down"
                :value="searchText"
                @input="inputSearchText"
                @change="updateSearchText"
            />
            <v-spacer v-if="hideSearchBar" />
            <slot></slot>
        </template>
        <div v-else class="px-8 d-flex flex-grow-1 align-center">
            <v-progress-linear indeterminate color="grey lighten-2" height="2"></v-progress-linear>
        </div>
    </v-toolbar>
</template>

<style scoped>
.fixed-bar {
    position: sticky !important;
    position: -webkit-sticky !important; /* for Safari */
    /* top: 64px !important; */
    top: 0px !important;
    width: 100% !important;
    z-index: 2 !important;
}
</style>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
    // searchText = "";
    searching = false;

    @Prop({ required: false, default: false, type: Boolean })
    hideSearchBar!: boolean;

    @Prop({ default: "" })
    icon?: string;

    @Prop({ default: "Sin título" })
    title?: string;

    @Prop({ default: "Sin título" })
    subtitle?: string;

    @Prop({ default: "Buscar aquí ..." })
    searchLabel?: string;

    @Prop({ default: "", type: String })
    searchText?: string;

    @Prop({ default: false, type: Boolean })
    realtime?: boolean;

    @Prop({ default: false, type: Boolean })
    loading?: boolean;

    lastValue = "";

    created() {
        this.lastValue = this.searchText || "";
    }

    inputSearchText(value: string) {
        if (this.realtime) {
            this.debounce(value);
        } else {
            if (!value) {
                this.updateSearchText(value);
            }
        }
    }

    @Watch("searchText")
    updateSearchText(value: string) {
        const normalizedValue = (value || "").trim();

        if (normalizedValue !== this.lastValue) {
            this.lastValue = normalizedValue;
            this.$emit("searchTextChanged", normalizedValue);
        }
    }

    timeoutID: any = null;

    debounce(value: string) {
        clearTimeout(this.timeoutID);
        this.timeoutID = setTimeout(() => {
            this.updateSearchText(value);
        }, 300);
    }
}
</script>
